//@flow
const getObjProp = (dataObj:Object, propName:string) => {
  return dataObj.hasOwnProperty(propName) ? dataObj[propName] : "Is not found!";
};
export default getObjProp;